export default function bannerClose() {
    const bannerElement = document.getElementById('banner');
    const closeButton = document.querySelector('.close');
    const homeHero = document.querySelector('.hero-home ');

    if (bannerElement && homeHero) {
        homeHero.classList.add('banner-active');

        if(closeButton){
            closeButton.addEventListener('click', function() {
                bannerElement.classList.remove('active');
                bannerElement.style.display = 'none'; 
    
                document.cookie = `banner_dismissed=${bannerElement.getAttribute('data-bannerid')}; path=/`;
            });
        }
    }
}
